export default __webpack_public_path__ + "static/media/79t.632b92c9.jpg";